import { Injectable, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport, withXhr } from "@angular/common/http";
import { CommonModule, Location } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { MainComponent } from "./main/main.component";
import { SpeedService } from "./_service/speed.service";
import { PingService } from "./_service/ping.service";
import { DownloadService } from "./_service/download.service";
import { UploadService } from "./_service/upload.service";
import { IpService } from "./_service/ip.service";
import { IspService } from "./_service/isp.service";
import { StoreService } from "./_service/store.service";
import { ServerService } from "./_service/server.service";
import { HelperService } from "./_service/helper.service";
import { APIService } from "./_service/api.service";
import { ISGService } from "./_service/isg.service";
import { NavheaderComponent } from "./navheader/navheader.component";
import { FooterComponent } from "./footer/footer.component";
import { StartButtonComponent } from "./_components/start-button/start-button.component";
import { RetryButtonComponent } from "./_components/retry-button/retry-button.component";
import { TestComponent } from "./test/test.component";
import { ResultComponent } from "./result/result.component";
import { ProgressService } from "./test/progress.service";
import { RoundProgressModule } from "angular-svg-round-progressbar";
import { CookieService } from "ngx-cookie-service";
import { provideTranslateService, TranslatePipe } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

import { NgxDatatableModule } from "@swimlane/ngx-datatable";


import { HistoryComponent } from "./history/history.component";
import { SettingsComponent } from "./settings/settings.component";
import { AccountComponent } from "./account/account.component";
import { PasswordStrengthComponent } from "./_shared/password-strength/password-strength.component";

import { AlertService } from "./_service/alert.service";
import { AlertComponent } from "./_directives/alert.component";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AuthGuard } from "./_guards/auth.guard";
import { AuthenticationService } from "./_service/authentication.service";
import { LoginComponent } from "./login/login.component";
import { LogoutComponent } from "./logout/logout.component";
import { RegisterComponent } from "./register/register.component";
import { ForgotComponent } from "./forgot/forgot.component";
import { ResetComponent } from "./reset/reset.component";

import { GlobalEventsService } from "./_service/globalevents.service";

import { GeoLocationService } from "./_service/geolocation.service";

import { ChartService } from "./_service/chart.service";

import { NgSelectModule } from "@ng-select/ng-select";

import { GoogleMapsModule } from "@angular/google-maps";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { CollapseModule } from "ngx-bootstrap/collapse";


import { TestsChartComponent } from "./_components/tests-chart/tests-chart.component";

import { AffiliateService } from "./_service/affiliate.service";
import { AnalyticsDirective } from "./_directives/analytics.directive";

import { PDFService } from "./_service/pdf.service";

// import localeEn from '@angular/common/locales/en';
// import localeEnExtra from '@angular/common/locales/extra/en';
// import localeFr from '@angular/common/locales/fr';
// import localeDE from '@angular/common/locales/de';
// // other locales...
// // registerLocaleData(localeEn, 'en', localeEnExtra);
// // registerLocaleData(localeFr);
// // registerLocaleData(localeDE);

import { environment } from "../environments/environment";


// export function HttpLoaderFactory(http: HttpClient) {
//     return new TranslateHttpLoader(http);
// }

// import { Injectable } from '@angular/core';
// import { Location } from '@angular/common';

// @Injectable()
// export class UnstripTrailingSlashLocation extends Location {
//   public static stripTrailingSlash(url: string): string {
//     return url;
//   }
// }

// Location.stripTrailingSlash = UnstripTrailingSlashLocation.stripTrailingSlash;

// Location.stripTrailingSlash = function stripTrailingSlashNew(url: string) {
//     console.log(url)
//   return url;
// };

@Injectable()
export class UnstripTrailingSlashLocation extends Location {
  public static stripTrailingSlash(url: string): string {
    return url;
  }
}

Location.stripTrailingSlash = UnstripTrailingSlashLocation.stripTrailingSlash;

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CommonModule,
    BrowserAnimationsModule,
    RoundProgressModule,
    NgxDatatableModule,
    TranslatePipe,
    GoogleMapsModule,
    NgSelectModule,
    CollapseModule,
    BsDatepickerModule,
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    LogoutComponent,
    RegisterComponent,
    ForgotComponent,
    ResetComponent,
    AlertComponent,
    MainComponent,
    HistoryComponent,
    SettingsComponent,
    AccountComponent,
    NavheaderComponent,
    FooterComponent,
    StartButtonComponent,
    RetryButtonComponent,
    TestComponent,
    ResultComponent,
    TestsChartComponent,
    AnalyticsDirective,
    PasswordStrengthComponent,
  ],
  providers: [
    provideHttpClient(withXhr(), withInterceptorsFromDi(), withJsonpSupport()),
    provideTranslateService({
      // English is the starting and fallback language; AppComponent switches to the i18n cookie's language
      lang: "en",
      fallbackLang: "en",
      loader: provideTranslateHttpLoader({
        prefix: environment.production ? "https://cf-cdn.speedcheck.org/assets/i18n/" : "./assets/i18n/",
        suffix: ".json",
      }),
    }),
    AuthGuard,
    AuthenticationService,
    AlertService,
    SpeedService,
    IpService,
    IspService,
    PingService,
    DownloadService,
    UploadService,
    StoreService,
    ProgressService,
    ServerService,
    HelperService,
    APIService,
    CookieService,
    GlobalEventsService,
    ChartService,
    GeoLocationService,
    AffiliateService,
    ISGService,
    PDFService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
